import React from 'react';
import { View } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import { IS_WEB } from '@/utils/platform';

export const Filter = ({
  color,
  size = 24,
  style,
  fillColor,
  ...props
}: IconProps) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 44 44"
          fill={fillColor}
          style={style as React.CSSProperties}
        >
          <path
            d="M24.7495 31.6283C24.7995 31.9949 24.6745 32.386 24.387 32.6426C24.2714 32.7559 24.1341 32.8458 23.9829 32.9071C23.8317 32.9684 23.6696 33 23.5059 33C23.3422 33 23.1801 32.9684 23.0289 32.9071C22.8777 32.8458 22.7404 32.7559 22.6248 32.6426L17.613 27.7422C17.4767 27.6118 17.3731 27.4525 17.3103 27.2765C17.2474 27.1006 17.227 26.9128 17.2505 26.7279V20.4709L11.2638 12.9797C11.0609 12.725 10.9693 12.402 11.0091 12.0814C11.0489 11.7609 11.2169 11.4687 11.4763 11.2689C11.7138 11.0978 11.9762 11 12.2512 11H29.7488C30.0238 11 30.2862 11.0978 30.5237 11.2689C30.7831 11.4687 30.9511 11.7609 30.9909 12.0814C31.0307 12.402 30.9391 12.725 30.7362 12.9797L24.7495 20.4709V31.6283ZM14.8009 13.4441L19.7502 19.6277V26.3735L22.2498 28.8176V19.6155L27.1991 13.4441H14.8009Z"
            fill={color}
          />
        </svg>
      </View>
    );
  }

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 44 44"
      fill={fillColor}
      style={style}
      {...props}
    >
      <Path
        d="M24.7495 31.6283C24.7995 31.9949 24.6745 32.386 24.387 32.6426C24.2714 32.7559 24.1341 32.8458 23.9829 32.9071C23.8317 32.9684 23.6696 33 23.5059 33C23.3422 33 23.1801 32.9684 23.0289 32.9071C22.8777 32.8458 22.7404 32.7559 22.6248 32.6426L17.613 27.7422C17.4767 27.6118 17.3731 27.4525 17.3103 27.2765C17.2474 27.1006 17.227 26.9128 17.2505 26.7279V20.4709L11.2638 12.9797C11.0609 12.725 10.9693 12.402 11.0091 12.0814C11.0489 11.7609 11.2169 11.4687 11.4763 11.2689C11.7138 11.0978 11.9762 11 12.2512 11H29.7488C30.0238 11 30.2862 11.0978 30.5237 11.2689C30.7831 11.4687 30.9511 11.7609 30.9909 12.0814C31.0307 12.402 30.9391 12.725 30.7362 12.9797L24.7495 20.4709V31.6283ZM14.8009 13.4441L19.7502 19.6277V26.3735L22.2498 28.8176V19.6155L27.1991 13.4441H14.8009Z"
        fill={color}
      />
    </Svg>
  );
};
